import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from "@auth0/auth0-react";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider audience="https://mrp-backend-6s5p.onrender.com" domain="auth.myregplates.com" clientId="jz2Srv6g7oNYPiWJkoI9SoNcnsUzIpPc" redirectUri={window.location.origin} useRefreshTokens={true} cacheLocation="localstorage">
      <BrowserRouter>
        <App />
      </BrowserRouter>
  </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
